// extracted by css-extract-rspack-plugin
export default {"indicator":"Tabs_indicator__F3JOX"};